module.exports = __webpack_public_path__ + "84f0be7c30fcd5f0605cad976c39687a.obj";